import type { OrderSystemInvoiceAmount } from "@cyh/contracts";

const amountFormatter = new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function formatOrderInvoiceAmounts(amounts: OrderSystemInvoiceAmount[] | undefined, pendingLabel: string): string {
  if (!amounts?.length) return "—";
  return amounts.map(({ currency, amount, pendingAmount }) =>
    `${currency} ${amountFormatter.format(amount)}${pendingAmount > 0 ? ` (${pendingLabel} ${currency} ${amountFormatter.format(pendingAmount)})` : ""}`
  ).join(" · ");
}
